namespace GeniuzPOS.Common.Helpers {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class ApproveFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            
            if (chanel == 0) {
                return "<i class='fa fa-file text-danger'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFB6C1; color: #CD5C5C; border: none;'>ยังไม่อนุมัติ</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-check-square text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>อนุมัติแล้ว</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }

    
    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class StatusFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            
            if (chanel == 0) {
                return "<i class='fa fa-file text-danger'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFB6C1; color: #CD5C5C; border: none;'>ยังไม่ใช้งาน</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-check-square text-success'></i> " +
                       "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>เปิดใช้งานอยู่</button>";
            } else {
                return chanel;
            }


        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }
@Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
export class ConsignFgFormatter implements Slick.Formatter {

    format(ctx: Slick.FormatterContext) {
        var text = Q.htmlEncode(ctx.value);

        if (!this.chanalPropertyId) {
            return text;
        }

        let chanel = ctx.item[this.chanalPropertyId];
        
        if (chanel == 0) {
            return "<i class='fa fa-credit-card text-primary'></i> " +
                   "<button class='btn btn-sm' style='background-color: #ADD8E6; color: #4169E1; border: none;'>สินค้าเครดิต</button>";
        } else if (chanel == 1) {
            return "<i class='fa fa-handshake-o text-warning'></i> " +
                   "<button class='btn btn-sm' style='background-color: #FFE4B5; color: #DAA520; border: none;'>สินค้าฝากขาย</button>";
        } else {
            return chanel;
        }
    }

    @Serenity.Decorators.option()
    public chanalPropertyId: string;

    public initializeColumn(column: Slick.Column) {
        column.referencedFields = column.referencedFields || [];
        if (this.chanalPropertyId)
            column.referencedFields.push(this.chanalPropertyId);
    }
}

    

}